const DEFAULT_HERO_VIDEO_URL = "/home-v3/bg_video.mp4";
const DEFAULT_BUSINESS_SUPPORT_VIDEO_URL = "/home-v3/bg-video.mp4";

export const HERO_VIDEO_URL =
  process.env.NEXT_PUBLIC_HERO_VIDEO_URL?.trim() || DEFAULT_HERO_VIDEO_URL;

export const BUSINESS_SUPPORT_VIDEO_URL =
  process.env.NEXT_PUBLIC_BUSINESS_SUPPORT_VIDEO_URL?.trim() ||
  DEFAULT_BUSINESS_SUPPORT_VIDEO_URL;

